import React from "react"

const stats = [
  { value: "18+", label: "Years of Practice" },
  { value: "340+", label: "Projects Completed" },
  { value: "42", label: "Industry Awards" },
  { value: "28", label: "Countries" },
]

export default function StatsSection() {
  return (
    <section className="py-20 lg:py-28 bg-stone-900 border-y border-stone-800">
      <div className="max-w-screen-2xl mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-0 lg:divide-x divide-stone-800">
          {stats.map((stat) => (
            <div key={stat.label} className="text-center lg:py-4">
              <div className="font-['Cormorant_Garamond'] text-5xl lg:text-7xl font-light text-amber-400 mb-2 leading-none">
                {stat.value}
              </div>
              <div className="font-['Space_Grotesk'] text-[10px] tracking-[0.25em] text-stone-500 uppercase">
                {stat.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
